import { Flavor, GeneratedContent, Tag } from "../../utils/types";

export const mapFlavorsToOptions = (flavors?: Flavor[]) =>
    flavors?.map((f) => ({ label: f.name, value: f.id, color: f.color })) ?? [];

export const mapFlavorsToSelectedOptions = (flavors?: Flavor[]) =>
    flavors?.map((f) => ({ label: f.name, value: f.id })) ?? [];

export const mapTagsToOptions = (tags?: Tag[]) => tags?.map((t) => ({ label: t.name, value: t.id })) ?? [];

export const mapGeneratedEffectsToSelectedOptions = (effects: GeneratedContent["effects"]) =>
    effects.map((e) => ({ label: e.effect_name })) ?? [];

export const mapSelectedOptionsToEffects = (
    selectedOptions: Array<{ label: string; [key: string]: any }>,
    existingEffects: GeneratedContent["effects"]
) => {
    return selectedOptions.map((option) => ({
        effect_name: option.label,
        intensity: existingEffects?.find((e) => e.effect_name === option.label)?.intensity ?? 50,
    }));
};
